import React from "react";
import UserScreenWindow from "../../Components/UserScreenWindow";
import Meralco from "./billerlogos/meralco.png";
import Globe from "./billerlogos/globe.png";
import PLDT from "./billerlogos/pldt.png";
import { FaMoneyBillWave, FaStar, FaHistory } from "react-icons/fa";

function BillsPayment() {
  const favoriteBillers = [
    {
      name: "Meralco",
      icon: Meralco,
      link: "/meralco",
    },
    {
      name: "Globe",
      icon: Globe,
      link: "/globe",
    },
    {
      name: "PLDT",
      icon: PLDT,
      link: "/pldt",
    },
  ];

  return (
    <UserScreenWindow label="Bills Payment">
      <div className="w-full mx-auto px-4 max-w-4xl">
        <div className="flex items-center justify-between mb-6 bg-[#363062]/5 p-4 rounded-lg">
          <div className="flex items-center space-x-3">
            <div className="p-2 bg-[#363062] rounded-lg">
              <FaMoneyBillWave className="text-white text-base" />
            </div>
            <div>
              <h1 className="text-sm font-medium text-[#363062]">
                Bills Payment
              </h1>
              <p className="text-xs text-gray-500">
                Pay your bills quickly and securely
              </p>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <div className="flex items-center mb-3">
            <FaStar className="text-[#8FCD00] mr-2 text-sm" />
            <h2 className="text-sm font-medium text-[#363062]">
              Favorite Billers
            </h2>
          </div>
          <div className="grid grid-cols-2 gap-4">
            {favoriteBillers.map((biller) => (
              <div
                key={biller.name}
                className="flex items-center p-3 bg-white rounded-lg border border-gray-100 hover:shadow-md transition-all cursor-pointer"
              >
                <img src={biller.icon} alt={biller.name} className="h-8 mr-3" />
                <span className="text-sm text-[#363062]">{biller.name}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-gray-50 rounded-lg border border-gray-100 p-6 text-center">
          <div className="p-3 bg-[#8FCD00]/10 rounded-full w-12 h-12 mx-auto mb-3 flex items-center justify-center">
            <FaHistory className="text-[#8FCD00] text-lg" />
          </div>
          <h3 className="text-sm font-medium text-[#363062] mb-1">
            Coming Soon
          </h3>
          <p className="text-xs text-gray-500">
            We're working on bringing you more payment options
          </p>
        </div>
      </div>
    </UserScreenWindow>
  );
}

export default BillsPayment;